/*
 * @Author: Json Chen
 * @Date: 2021-07-12 09:30:07
 * @LastEditTime: 2022-05-16 13:12:21
 * @LastEditors: Teemo Ding
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/request/settings/logistics/wareHouseLocation.ts
 */

import { get, post } from 'src/tools/server';

// 获取页面country/region 和phone 的area 的接口
export const getWareHouseLocationPage = () => {
  return get<any>(`/portal/setting/store/logistics/wareHouseLocation/page`, {});
};

// onSave
export const setWareHouseLocation = (body: any) => {
  return post<any>(
    `/portal/setting/store/logistics/wareHouseLocation`,
    body,
    {},
  );
};

// 获取地址经纬度
export const getWareHouseLocationGeo = (body: any) => {
  return post<any>(
    `/portal/setting/store/logistics/wareHouseLocation/geo`,
    body,
    {},
  );
};

// 获取wareHouse 列表
export const getWareHouseLocations = () => {
  return get<any>(`/portal/setting/store/logistics/activatedWarehouses`, {});
};

// setActive
export const setWareHouseLocationActivate = (uuid) => {
  return get<any>(
    `/portal/setting/store/logistics/wareHouseLocation/activate/${uuid}`,
    {},
  );
};

// setDeActive
export const setWareHouseLocationDeactivate = (uuid) => {
  return get<any>(
    `/portal/setting/store/logistics/wareHouseLocation/deactivate/${uuid}`,
    {},
  );
};
// detail
export const getWareHouseLocation = (uuid) => {
  return get<any>(
    `/portal/setting/store/logistics/wareHouseLocation/${uuid}`,
    {},
  );
};
//get api address
export const getApiAddress = (courierType: string) => {
  return get<any>(
    `/portal/setting/store/logistics/courierServerAddresses/${courierType}`,
    {},
  );
};
// 设置排序
export const setWareHouseLocationOrder = (body: any) => {
  return post<any>(
    `/portal/setting/store/logistics/wareHouseLocation/order`,
    body,
    {},
  );
};
